import table from './table';
import tableCell from './tableCell';
import tableHeader from './tableHeader';
import tableRow from './tableRow';
import { ResourceType } from './types';

const unconfiguredPlugins = [table, tableRow, tableHeader, tableCell];

/**
 * Call this function to retreive an array of configured table plugins.
 * @param resourceType
 * @returns
 */
function TablePlugins(resourceType: ResourceType) {
  return unconfiguredPlugins.map((p) => p.configure({ resourceType } as any));
}

export { unconfiguredPlugins as unconfiguredTablePlugins };

export default TablePlugins;
